import { render, staticRenderFns } from "./PhoneShort.vue?vue&type=template&id=4cf91b7c&scoped=true"
import script from "./PhoneShort.vue?vue&type=script&lang=js"
export * from "./PhoneShort.vue?vue&type=script&lang=js"
import style0 from "./PhoneShort.vue?vue&type=style&index=0&id=4cf91b7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf91b7c",
  null
  
)

export default component.exports